var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDpIconGreenOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5633 0.0675982C26.5633 0.0675982 15.5479 -0.193765 15.5479 10.3644C15.5479 16.6236 20.518 20.8009 24.3102 23.401C25.0865 23.9328 25.9922 24.3428 26.5633 24.3428C27.1343 24.3428 28.04 23.9373 28.8163 23.401C32.6086 20.8009 37.5832 16.6236 37.5832 10.3644C37.5832 -0.193765 26.5677 0.0675982 26.5633 0.0675982ZM26.5633 14.7896C23.9756 14.7896 21.8787 12.6716 21.8787 10.058C21.8787 7.44435 23.9756 5.3264 26.5633 5.3264C29.1509 5.3264 31.2478 7.44435 31.2478 10.058C31.2478 12.6716 29.1509 14.7896 26.5633 14.7896Z",
    fill: "url(#paint0_linear_40_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0557 0.0766065C15.2271 0.0766065 15.2271 0.0766066 15.2271 2.24412L15.2405 9.49018C13.8708 8.90888 12.3985 8.61146 10.9128 8.61146C4.88534 8.60696 0 13.4106 0 19.3319C0 25.2531 4.88534 30.0523 10.9128 30.0523C12.4788 30.0523 13.9645 29.7278 15.3074 29.1465C15.4814 30.0523 16.1149 30.0523 18.4483 30.0523C21.8256 30.0523 21.8256 30.0523 21.8256 27.7V2.32072L18.0557 0V0.0766065ZM11.3813 23.8516C8.93637 23.8516 6.95547 21.8509 6.95547 19.3814C6.95547 16.912 8.93637 14.9112 11.3813 14.9112C13.8262 14.9112 15.8071 16.912 15.8071 19.3814C15.8026 21.8509 13.8217 23.8516 11.3813 23.8516Z",
    fill: "url(#paint1_linear_40_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.5547 27.6188C24.8683 27.6414 23.5031 28.0514 23.512 28.5336C23.5164 29.0158 24.8906 29.3898 26.5815 29.3627C28.2679 29.3402 29.6331 28.9301 29.6242 28.448C29.6153 27.9703 28.2411 27.5963 26.5547 27.6188Z",
    fill: "url(#paint2_linear_40_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_2",
    x1: 26.566,
    y1: 7.48307,
    x2: 26.566,
    y2: 24.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D57300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_2",
    x1: 10.9128,
    y1: 0,
    x2: 10.9128,
    y2: 30.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63D270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F954D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_2",
    x1: 26.5379,
    y1: 26.3983,
    x2: 26.5425,
    y2: 30.5272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A623"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpIconGreenOrange);
export default __webpack_public_path__ + "static/media/dp-icon-green-orange.b8f9c0129fbe853561feda178b1124b3.svg";
export { ForwardRef as ReactComponent };